import type { FunctionComponent } from 'react';
import { useEffect } from 'react';
import { SubNavigationTabTotalWealth } from '../../enums';
import { useNumberSearchParams } from '../../hooks/useNumberSearchParams';
import { CashFlowChartScreen } from './CashFlowChartScreen';
import { WealthOverviewScreen } from './WealthOverviewScreen';

export const WealthScreen: FunctionComponent = () => {
    const [tab, setSearchParams] = useNumberSearchParams('tab');

    useEffect(() => {
        if (tab === undefined) setSearchParams({ tab: (0).toString() });
    }, [tab, setSearchParams]);

    return (
        <>
            {tab === SubNavigationTabTotalWealth.WEALTH_OVERVIEW && <WealthOverviewScreen />}
            {tab === SubNavigationTabTotalWealth.CASHFLOWS && <CashFlowChartScreen />}
        </>
    );
};
